import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob/WobGliderBase'

export interface IWobAisStatusConstParam extends IWobGliderBaseConstParam {
  aisStatus: 'OFF' | 'NO_RISK' | 'RISK' | 'NO_DATA'
}

export class WobAisStatus extends WobGliderBase {
  public aisStatus: 'OFF' | 'NO_RISK' | 'RISK' | 'NO_DATA'

  constructor({ aisStatus, ...args }: IWobAisStatusConstParam) {
    super(args)
    this.aisStatus = aisStatus
  }
}
